var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpicyTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.94,73.56c11.8-8.07,10.27-18.19,10.34-18.33a4.39,4.39,0,0,1,8.58,1.83A38.55,38.55,0,0,1,161,79.2C160.37,79.64,160.12,76.1,154.94,73.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.06,162.58c-9.84,0-17.54-2-22.45-4.84-5.43-3.18-5.91-6.75-5.71-8.59s1.37-5,7.05-6.87h0c35.79-11.55,42.16-19,57.53-37.06,4-4.76,8.65-10.16,14.53-16.54C123.58,74.92,137,67.4,148,68.06c6.37.38,11.86,3.55,15.86,9.15,15.29,21.49-9.61,43.06-29.67,57.4C104.77,155.6,78.62,162.57,60.06,162.58ZM38.79,149.93c.35.58,1.78,2,5.6,3.41,12.79,4.59,45.27,4.64,85.77-24.29,28.09-20.1,37-35.31,28.08-47.87-2.84-4-6.34-6-10.7-6.29-8.69-.52-20.47,6.36-31.49,18.42-5.8,6.29-10.35,11.63-14.36,16.34-15.79,18.54-23,27-60.64,39.15h0A5.93,5.93,0,0,0,38.79,149.93Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicyTag);
export default __webpack_public_path__ + "static/media/SpicyTag.48efac84c9eee8bf10b710c69fe1e713.svg";
export { ForwardRef as ReactComponent };